export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/MK-362bc4fa6dc05eba2db02f0d4f35633d.png";